import React from 'react';

interface QuoteBlockProps {
  children: React.ReactNode;
}

export const QuoteBlock: React.FC<QuoteBlockProps> = ({ children }) => {
  return (
    <div className="quote-block">
      {children}
    </div>
  );
};
